(() => {
  'use strict';
  if (window.JSGSaleClock) return;
  window.JSGSaleClock = true;
  let demoDeadline;
  try { demoDeadline = Number(sessionStorage.getItem('jsg_preview_sale_until')); } catch (_) {}
  if (!Number.isFinite(demoDeadline) || demoDeadline <= Date.now()) { demoDeadline = Date.now() + 6 * 3600000; try { sessionStorage.setItem('jsg_preview_sale_until', String(demoDeadline)); } catch (_) {} }
  function update() {
    const header = document.querySelector('[data-jsg-sale-timer][data-jsg-deadline]');
    if (!header) return;
    const configured = Date.parse(header.dataset.jsgDeadline || '');
    const demo = !Number.isFinite(configured) && header.dataset.jsgPreview === 'true';
    const deadline = Number.isFinite(configured) ? configured : demo ? demoDeadline : NaN;
    document.querySelectorAll('[data-jsg-sale-timer]').forEach(timer => {
      const container = timer.closest('[data-jsg-sale-timer-container]') || timer;
      container.hidden = !Number.isFinite(deadline);
      if (container.hidden) return;
      timer.dataset.timerMode = demo ? 'preview' : 'scheduled';
      timer.title = demo ? 'Draft preview timer — configure the actual closing date before publishing.' : 'Closing time: ' + new Date(deadline).toLocaleString('en-SG', {timeZone:'Asia/Singapore'});
      const total = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      const values = [Math.floor(total / 3600), Math.floor(total % 3600 / 60), total % 60];
      ['hours','minutes','seconds'].forEach((unit,index) => { const node=timer.querySelector('[data-jsg-'+unit+']');if(node)node.textContent=String(values[index]).padStart(2,'0'); });
    });
  }
  update(); setInterval(update,1000); document.addEventListener('shopify:section:load',update);
})();
